export const BACKEND_URL = process.env.REACT_APP_API_URL;
export const API_URL = BACKEND_URL + "/api";
export const API_TOKEN = "8ebd28d36ccccc5e34b14e2fdd8b4c";
export * from "./theme";
